import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { IAthleteBiography } from './athlete-biography-store';

/**
 * An interface that shows the world ranking history of an athlete
 *
 * @export
 * @interface IWorldRankingHistory
 */
export interface IWorldRankingHistory {
  Rnk: number;
  RnkOld: number;
  Points: number;
  RnkDtIssued: string;
}


/**
 * The store for get the athlete history
 *
 * @export
 * @class AthleteWorldRankingHistory
 * @extends {EntitiesStore<IAthleteBiography>}
 */
export class AthleteWorldRankingHistory extends EntitiesStore<IWorldRankingHistory> {
  constructor(http: HttpClient, injector: Injector) {
    super('WORLDRANKINGHISTORY', http);
  }
}
